import GlobalSettings from "@/services/resources/GlobalSettings"

const actions = {
    async checkBetaSeller({ commit, rootGetters }, keyBetaSeller='MY_ACCOUNT_BETA_SELLERS' ) {
      console.log('checkBetaSeller executando', keyBetaSeller)
      try {
        const serviceGlobalSettings = GlobalSettings.build()
        let userID = rootGetters.getProfile.id
        
        const response = await serviceGlobalSettings.search({ 
          keys: keyBetaSeller 
        })

        for (const item of response) {
          if (item.key === keyBetaSeller) {
            let betaSellers = item.value ? item.value.split(',') : []
            console.log('betaSellers BETA', betaSellers)
            if (!betaSellers.length || betaSellers[0].trim() === "") {
              commit('setBetaSeller', true)
              return true
            }
            if(userID) {
              let isBeta = betaSellers.includes(userID.toString())
              console.log('isBeta BETA', isBeta)
              commit('setBetaSeller', isBeta)
              return isBeta
            }
          }
        }

        commit('setBetaSeller', false)
        return false
        
      } catch (error) {
        console.error('Error checking beta seller:', error)
        commit('setBetaSeller', false)
        return false
      }
    }
}

export default actions
